import { connectInstructions } from "../../util/redux";
import EmotionInstructionsComponent from "../../components/emotion/instructions";

const EmotionInstructions = connectInstructions(EmotionInstructionsComponent);

export default EmotionInstructions;
